<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term0">
      <div class="term0-content">
        <el-table
          ref="tb"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
          @selection-change="handleDetailSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="指标类别">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <!-- <el-input v-model="scope.row.zbmc" placeholder="" /> -->
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="top"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bz" label="申请标准">
            <template slot-scope="scope" inline-template>
              <el-select
                v-if="scope.row.equipstandardopt.optional"
                v-model="scope.row.sz"
                disabled:false
                placeholder="请选择"
              >
                <el-option
                  v-for="item in scope.row.equipstandardopt.optional"
                  :key="item.value"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-else
                v-model="scope.row.sz"
                placeholder=""
                :disabled="
                  scope.row.equipstandardopt.readOnly[0] == true ? true : false
                "
              />
            </template>
          </el-table-column>
          <el-table-column prop="num" label="申报数量" />
          <el-table-column prop="status" label="状态">
            <template>
              <el-button type="text">
                查看
              </el-button>
              <span class="pad-row4">|</span>
              <el-button type="text">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import mock from '@/utils/mock'
export default {
  name: 'ComTerm0',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      dm: '',
      content: '查看指标解释查看指标解释',
      checkedDetail: []
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleDetailSelectionChange(selection) {
      if (selection.length > 1) {
        this.$refs.tb.clearSelection()
        this.$refs.tb.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail = selection
      }
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      this.$emit('next')
    },
    handleOpen() {
      this.$alert(this.content, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term0 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
  }
}
.term0-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
